<template>
  <sweet-modal modal-theme="light" overlay-theme="dark" ref="modal-parcel-detail" class="custom-width" width="70%">
    <h3>HAWB: {{ modals.header }}</h3>
    <el-table
      :data="tableData"
      align="center"
      style="width: 100%;">
      <el-table-column
        prop="key"
        align="right"
        label=""
        width="250">
      </el-table-column>
      <el-table-column
        prop="value"
        label=""
        width="400">
      </el-table-column>
    </el-table>

    <br>
    <h3>Status History</h3>
    <el-table
      :data="statusHistory"
      style="width: 100%">
      <el-table-column
        prop="topic"
        label="Topic">
      </el-table-column>
      <el-table-column
        prop="reason"
        label="Reason">
      </el-table-column>
      <el-table-column
        prop="status"
        label="Status">
      </el-table-column>
      <!-- <el-table-column
        prop="reasonCode"
        label="Reason Code">
      </el-table-column> -->
      <el-table-column
        prop="reasonDescription"
        label="Reason Description">
      </el-table-column>
      <el-table-column
        prop="timestamp"
        label="Timestamp"
        :formatter="formatDate">
      </el-table-column>
    </el-table>
    <!-- <el-form :label-position="`right`" label-width="250px">
      <el-form-item label="RefNo" align="left">{{ modals.content.refNo }}
      </el-form-item>
      <el-form-item label="BagRefNo" align="left">{{ modals.content.bagRefNo }}
      </el-form-item>
      <el-form-item label="DeclarationNo" align="left">{{ modals.content.declarationNo }}
      </el-form-item>
      <el-form-item label="Vessel" align="left">{{ modals.content.vessel }}
      </el-form-item>
      <el-form-item label="ArrivalDate" align="left">{{ modals.content.arrivalDate }}
      </el-form-item>
      <el-form-item label="MAWB" align="left">{{ modals.content.mawb }}
      </el-form-item>
      <el-form-item label="HAWM" align="left">{{ modals.content.hawb }}
      </el-form-item>
      <el-form-item label="Category" align="left">{{ modals.content.category }}
      </el-form-item>
      <el-form-item label="ConsignorName" align="left">{{ modals.content.consignorName }}
      </el-form-item>
      <el-form-item label="StreetAndNumber" align="left">{{ modals.content.streetAndNumber }}
      </el-form-item>
      <el-form-item label="District" align="left">{{ modals.content.district }}
      </el-form-item>
      <el-form-item label="SubProvince" align="left">{{ modals.content.subProvince }}
      </el-form-item>
      <el-form-item label="Province" align="left">{{ modals.content.province }}
      </el-form-item>
      <el-form-item label="PostCode" align="left">{{ modals.content.postCode }}
      </el-form-item>
      <el-form-item label="ItemNo" align="left">{{ modals.content.itemNo }}
      </el-form-item>
      <el-form-item label="ENDescription" align="left">{{ modals.content.enDescription }}
      </el-form-item>
      <el-form-item label="THDescription" align="left">{{ modals.content.thDescription }}
      </el-form-item>
      <el-form-item label="TariffCode" align="left">{{ modals.content.tariffCode }}
      </el-form-item>
      <el-form-item label="Sequence" align="left">{{ modals.content.sequence }}
      </el-form-item>
      <el-form-item label="QTY" align="left">{{ modals.content.qty }}
      </el-form-item>
      <el-form-item label="QTYUnit" align="left">{{ modals.content.qtyUnit }}
      </el-form-item>
      <el-form-item label="Package" align="left">{{ modals.content.package }}
      </el-form-item>
      <el-form-item label="PackageUnit" align="left">{{ modals.content.packageUnit }}
      </el-form-item>
      <el-form-item label="Weight" align="left">{{ modals.content.weight }}
      </el-form-item>
      <el-form-item label="WeightUnit" align="left">{{ modals.content.weightUnit }}
      </el-form-item>
      <el-form-item label="Price" align="left">{{ modals.content.price }}
      </el-form-item>
      <el-form-item label="FOB" align="left">{{ modals.content.fob }}
      </el-form-item>
      <el-form-item label="CIF" align="left">{{ modals.content.cif }}
      </el-form-item>
      <el-form-item label="Currency" align="left">{{ modals.content.currency }}
      </el-form-item>
      <el-form-item label="DutyRate" align="left">{{ modals.content.dutyRate }}
      </el-form-item>
      <el-form-item label="Duty" align="left">{{ modals.content.duty }}
      </el-form-item>
      <el-form-item label="Vat" align="left">{{ modals.content.vat }}
      </el-form-item>
      <el-form-item label="NetBayStatus" align="left">{{ modals.content.netBayStatus }}
      </el-form-item>
      <el-form-item label="Status" align="left">{{ modals.content.status }}
      </el-form-item>
      <el-form-item label="UpdatedAt" align="left">{{ modals.content.updatedAt }}
      </el-form-item>
    </el-form> -->
  </sweet-modal>
</template>

<script>
export default {
  props: {
    modals: {
      notice: false,
      header: '',
      content: {
        id: "",
        refNo: "",
        bagRefNo: "",
        declarationNo: "",
        vessel: "",
        arrivalDate: {},
        mawb: "",
        hawb: "",
        category: "",
        consignorName: "",
        streetAndNumber: "",
        district: "",
        subProvince: "",
        province: "",
        postCode: "",
        itemNo: "",
        enDescription: "",
        thDescription: "",
        tariffCode: "",
        sequence: 0,
        qty: 0,
        qtyUnit: "",
        package: "",
        packageUnit: "",
        weight: 0.0,
        weightUnit: "KGM",
        price: 0.0,
        fob: 0.0,
        cif: 0.0,
        currency: "THB",
        dutyRate: 0,
        duty: 0.0,
        vat: 0.0,
        netBayStatus: "",
        historyInternalStatus: [],
        status: "",
        images: [],
        approved: false,
        updatedAt: ""
      },
    }
  },
  data: () => ({
    statusHistory: []
  }),
  watch: {
    'modals.notice': function(newVal, oldVal){
      if (newVal) {
        this.$refs['modal-parcel-detail'].open()
        this.$emit('afterModalShow')
      }
    },
    'modals.content': function(newVal, oldVal){
      if (newVal) {
        this.statusHistory = Array.from(newVal.historyInternalStatus)
      }
    },
    // modals (val) {

    //   if (val.notice) {
    //     this.$refs['modal-parcel-detail'].open()
    //     this.$emit('afterModalShow')
    //   }
    //   console.log(val)
    // },
    // modals: {
    //   handler: function (val, oldVal) {

    //   if (val.notice) {
    //     this.statusHistory = Array.from(val.content.historyInternalStatus)
    //     this.$refs['modal-parcel-detail'].open()
    //     this.$emit('afterModalShow')
    //   }
    //   console.log(val)

    //   },
    //   deep: true
    // }
  },
  computed: {
    tableData () {
      // historyInternalStatus, images, customerID
      let obj = this.modals.content
      delete obj.historyInternalStatus
      delete obj.images
      delete obj.customerID

      let result = Object.keys(obj).map(function(key) {
        return {
            key: key.toUpperCase()+":",
            value: obj[key]
          }
      })
      return result
    }
  },
  methods: {
    formatDate(row, column) {
      const date = row.timestamp
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear(),
          hours = d.getHours(),
          minutes = d.getMinutes(),
          seconds = d.getSeconds()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [day, month, year].join('-') + ' ' +[hours, minutes, seconds].join(':')
    },
  }
}
</script>

<style scoped lang="scss">
h3 {
  text-decoration: underline;
}
.custom-width {
  width: 100%;
}

</style>
